import { render, staticRenderFns } from "./showFileList-editor.vue?vue&type=template&id=556d12c0&scoped=true&"
import script from "./showFileList-editor.vue?vue&type=script&lang=js&"
export * from "./showFileList-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d12c0",
  null
  
)

export default component.exports